/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as coreClient from "@azure/core-client";

export const SystemData: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SystemData",
    modelProperties: {
      createdBy: {
        serializedName: "createdBy",
        type: {
          name: "String",
        },
      },
      createdByType: {
        serializedName: "createdByType",
        type: {
          name: "String",
        },
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime",
        },
      },
      lastModifiedBy: {
        serializedName: "lastModifiedBy",
        type: {
          name: "String",
        },
      },
      lastModifiedByType: {
        serializedName: "lastModifiedByType",
        type: {
          name: "String",
        },
      },
      lastModifiedAt: {
        serializedName: "lastModifiedAt",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const Resource: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Resource",
    modelProperties: {
      id: {
        serializedName: "id",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      type: {
        serializedName: "type",
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ErrorResponse: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ErrorResponse",
    modelProperties: {
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "ErrorDetail",
        },
      },
    },
  },
};

export const ErrorDetail: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ErrorDetail",
    modelProperties: {
      code: {
        serializedName: "code",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      message: {
        serializedName: "message",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      target: {
        serializedName: "target",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      details: {
        serializedName: "details",
        readOnly: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ErrorDetail",
            },
          },
        },
      },
      additionalInfo: {
        serializedName: "additionalInfo",
        readOnly: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ErrorAdditionalInfo",
            },
          },
        },
      },
    },
  },
};

export const ErrorAdditionalInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ErrorAdditionalInfo",
    modelProperties: {
      type: {
        serializedName: "type",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      info: {
        serializedName: "info",
        readOnly: true,
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const CaCertificatesListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CaCertificatesListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CaCertificate",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerTopicInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerTopicInfo",
    modelProperties: {
      azureSubscriptionId: {
        serializedName: "azureSubscriptionId",
        type: {
          name: "String",
        },
      },
      resourceGroupName: {
        serializedName: "resourceGroupName",
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      eventTypeInfo: {
        serializedName: "eventTypeInfo",
        type: {
          name: "Composite",
          className: "EventTypeInfo",
        },
      },
      source: {
        serializedName: "source",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EventTypeInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventTypeInfo",
    modelProperties: {
      kind: {
        serializedName: "kind",
        type: {
          name: "String",
        },
      },
      inlineEventTypes: {
        serializedName: "inlineEventTypes",
        type: {
          name: "Dictionary",
          value: {
            type: { name: "Composite", className: "InlineEventProperties" },
          },
        },
      },
    },
  },
};

export const InlineEventProperties: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "InlineEventProperties",
    modelProperties: {
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      displayName: {
        serializedName: "displayName",
        type: {
          name: "String",
        },
      },
      documentationUrl: {
        serializedName: "documentationUrl",
        type: {
          name: "String",
        },
      },
      dataSchemaUrl: {
        serializedName: "dataSchemaUrl",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ChannelUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ChannelUpdateParameters",
    modelProperties: {
      expirationTimeIfNotActivatedUtc: {
        serializedName: "properties.expirationTimeIfNotActivatedUtc",
        type: {
          name: "DateTime",
        },
      },
      partnerTopicInfo: {
        serializedName: "properties.partnerTopicInfo",
        type: {
          name: "Composite",
          className: "PartnerUpdateTopicInfo",
        },
      },
    },
  },
};

export const PartnerUpdateTopicInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerUpdateTopicInfo",
    modelProperties: {
      eventTypeInfo: {
        serializedName: "eventTypeInfo",
        type: {
          name: "Composite",
          className: "EventTypeInfo",
        },
      },
    },
  },
};

export const ChannelsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ChannelsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Channel",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EventSubscriptionFullUrl: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventSubscriptionFullUrl",
    modelProperties: {
      endpointUrl: {
        serializedName: "endpointUrl",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ClientGroupsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ClientGroupsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ClientGroup",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ClientCertificateAuthentication: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ClientCertificateAuthentication",
    modelProperties: {
      validationScheme: {
        serializedName: "validationScheme",
        type: {
          name: "String",
        },
      },
      allowedThumbprints: {
        serializedName: "allowedThumbprints",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const ClientsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ClientsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Client",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PrivateEndpoint: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PrivateEndpoint",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ConnectionState: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ConnectionState",
    modelProperties: {
      status: {
        serializedName: "status",
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      actionsRequired: {
        serializedName: "actionsRequired",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const InputSchemaMapping: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "InputSchemaMapping",
    uberParent: "InputSchemaMapping",
    polymorphicDiscriminator: {
      serializedName: "inputSchemaMappingType",
      clientName: "inputSchemaMappingType",
    },
    modelProperties: {
      inputSchemaMappingType: {
        serializedName: "inputSchemaMappingType",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const InboundIpRule: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "InboundIpRule",
    modelProperties: {
      ipMask: {
        serializedName: "ipMask",
        type: {
          name: "String",
        },
      },
      action: {
        serializedName: "action",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const IdentityInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "IdentityInfo",
    modelProperties: {
      type: {
        serializedName: "type",
        type: {
          name: "String",
        },
      },
      principalId: {
        serializedName: "principalId",
        type: {
          name: "String",
        },
      },
      tenantId: {
        serializedName: "tenantId",
        type: {
          name: "String",
        },
      },
      userAssignedIdentities: {
        serializedName: "userAssignedIdentities",
        type: {
          name: "Dictionary",
          value: {
            type: { name: "Composite", className: "UserIdentityProperties" },
          },
        },
      },
    },
  },
};

export const UserIdentityProperties: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "UserIdentityProperties",
    modelProperties: {
      principalId: {
        serializedName: "principalId",
        type: {
          name: "String",
        },
      },
      clientId: {
        serializedName: "clientId",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DomainUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DomainUpdateParameters",
    modelProperties: {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
      publicNetworkAccess: {
        serializedName: "properties.publicNetworkAccess",
        type: {
          name: "String",
        },
      },
      inboundIpRules: {
        serializedName: "properties.inboundIpRules",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "InboundIpRule",
            },
          },
        },
      },
      minimumTlsVersionAllowed: {
        serializedName: "properties.minimumTlsVersionAllowed",
        type: {
          name: "String",
        },
      },
      disableLocalAuth: {
        serializedName: "properties.disableLocalAuth",
        type: {
          name: "Boolean",
        },
      },
      autoCreateTopicWithFirstSubscription: {
        serializedName: "properties.autoCreateTopicWithFirstSubscription",
        type: {
          name: "Boolean",
        },
      },
      autoDeleteTopicWithLastSubscription: {
        serializedName: "properties.autoDeleteTopicWithLastSubscription",
        type: {
          name: "Boolean",
        },
      },
      dataResidencyBoundary: {
        serializedName: "properties.dataResidencyBoundary",
        type: {
          name: "String",
        },
      },
      eventTypeInfo: {
        serializedName: "properties.eventTypeInfo",
        type: {
          name: "Composite",
          className: "EventTypeInfo",
        },
      },
    },
  },
};

export const DomainsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DomainsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Domain",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DomainSharedAccessKeys: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DomainSharedAccessKeys",
    modelProperties: {
      key1: {
        serializedName: "key1",
        type: {
          name: "String",
        },
      },
      key2: {
        serializedName: "key2",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DomainRegenerateKeyRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DomainRegenerateKeyRequest",
    modelProperties: {
      keyName: {
        serializedName: "keyName",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DomainTopicsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DomainTopicsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DomainTopic",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DeliveryAttributeListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeliveryAttributeListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DeliveryAttributeMapping",
            },
          },
        },
      },
    },
  },
};

export const DeliveryAttributeMapping: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeliveryAttributeMapping",
    uberParent: "DeliveryAttributeMapping",
    polymorphicDiscriminator: {
      serializedName: "type",
      clientName: "type",
    },
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      type: {
        serializedName: "type",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DeliveryConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeliveryConfiguration",
    modelProperties: {
      deliveryMode: {
        serializedName: "deliveryMode",
        type: {
          name: "String",
        },
      },
      queue: {
        serializedName: "queue",
        type: {
          name: "Composite",
          className: "QueueInfo",
        },
      },
      push: {
        serializedName: "push",
        type: {
          name: "Composite",
          className: "PushInfo",
        },
      },
    },
  },
};

export const QueueInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "QueueInfo",
    modelProperties: {
      receiveLockDurationInSeconds: {
        serializedName: "receiveLockDurationInSeconds",
        type: {
          name: "Number",
        },
      },
      maxDeliveryCount: {
        serializedName: "maxDeliveryCount",
        type: {
          name: "Number",
        },
      },
      deadLetterDestinationWithResourceIdentity: {
        serializedName: "deadLetterDestinationWithResourceIdentity",
        type: {
          name: "Composite",
          className: "DeadLetterWithResourceIdentity",
        },
      },
      eventTimeToLive: {
        serializedName: "eventTimeToLive",
        type: {
          name: "TimeSpan",
        },
      },
    },
  },
};

export const DeadLetterWithResourceIdentity: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeadLetterWithResourceIdentity",
    modelProperties: {
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "EventSubscriptionIdentity",
        },
      },
      deadLetterDestination: {
        serializedName: "deadLetterDestination",
        type: {
          name: "Composite",
          className: "DeadLetterDestination",
        },
      },
    },
  },
};

export const EventSubscriptionIdentity: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventSubscriptionIdentity",
    modelProperties: {
      type: {
        serializedName: "type",
        type: {
          name: "String",
        },
      },
      userAssignedIdentity: {
        serializedName: "userAssignedIdentity",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DeadLetterDestination: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeadLetterDestination",
    uberParent: "DeadLetterDestination",
    polymorphicDiscriminator: {
      serializedName: "endpointType",
      clientName: "endpointType",
    },
    modelProperties: {
      endpointType: {
        serializedName: "endpointType",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PushInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PushInfo",
    modelProperties: {
      maxDeliveryCount: {
        serializedName: "maxDeliveryCount",
        type: {
          name: "Number",
        },
      },
      eventTimeToLive: {
        serializedName: "eventTimeToLive",
        type: {
          name: "String",
        },
      },
      deadLetterDestinationWithResourceIdentity: {
        serializedName: "deadLetterDestinationWithResourceIdentity",
        type: {
          name: "Composite",
          className: "DeadLetterWithResourceIdentity",
        },
      },
      deliveryWithResourceIdentity: {
        serializedName: "deliveryWithResourceIdentity",
        type: {
          name: "Composite",
          className: "DeliveryWithResourceIdentity",
        },
      },
      destination: {
        serializedName: "destination",
        type: {
          name: "Composite",
          className: "EventSubscriptionDestination",
        },
      },
    },
  },
};

export const DeliveryWithResourceIdentity: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DeliveryWithResourceIdentity",
    modelProperties: {
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "EventSubscriptionIdentity",
        },
      },
      destination: {
        serializedName: "destination",
        type: {
          name: "Composite",
          className: "EventSubscriptionDestination",
        },
      },
    },
  },
};

export const EventSubscriptionDestination: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventSubscriptionDestination",
    uberParent: "EventSubscriptionDestination",
    polymorphicDiscriminator: {
      serializedName: "endpointType",
      clientName: "endpointType",
    },
    modelProperties: {
      endpointType: {
        serializedName: "endpointType",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const FiltersConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "FiltersConfiguration",
    modelProperties: {
      includedEventTypes: {
        serializedName: "includedEventTypes",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      filters: {
        serializedName: "filters",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Filter",
            },
          },
        },
      },
    },
  },
};

export const Filter: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Filter",
    uberParent: "Filter",
    polymorphicDiscriminator: {
      serializedName: "operatorType",
      clientName: "operatorType",
    },
    modelProperties: {
      operatorType: {
        serializedName: "operatorType",
        required: true,
        type: {
          name: "String",
        },
      },
      key: {
        serializedName: "key",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const SubscriptionUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SubscriptionUpdateParameters",
    modelProperties: {
      deliveryConfiguration: {
        serializedName: "properties.deliveryConfiguration",
        type: {
          name: "Composite",
          className: "DeliveryConfiguration",
        },
      },
      eventDeliverySchema: {
        serializedName: "properties.eventDeliverySchema",
        type: {
          name: "String",
        },
      },
      filtersConfiguration: {
        serializedName: "properties.filtersConfiguration",
        type: {
          name: "Composite",
          className: "FiltersConfiguration",
        },
      },
      expirationTimeUtc: {
        serializedName: "properties.expirationTimeUtc",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const SubscriptionsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SubscriptionsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Subscription",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EventSubscriptionFilter: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventSubscriptionFilter",
    modelProperties: {
      subjectBeginsWith: {
        serializedName: "subjectBeginsWith",
        type: {
          name: "String",
        },
      },
      subjectEndsWith: {
        serializedName: "subjectEndsWith",
        type: {
          name: "String",
        },
      },
      includedEventTypes: {
        serializedName: "includedEventTypes",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      isSubjectCaseSensitive: {
        defaultValue: false,
        serializedName: "isSubjectCaseSensitive",
        type: {
          name: "Boolean",
        },
      },
      enableAdvancedFilteringOnArrays: {
        serializedName: "enableAdvancedFilteringOnArrays",
        type: {
          name: "Boolean",
        },
      },
      advancedFilters: {
        serializedName: "advancedFilters",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AdvancedFilter",
            },
          },
        },
      },
    },
  },
};

export const AdvancedFilter: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "AdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: {
      serializedName: "operatorType",
      clientName: "operatorType",
    },
    modelProperties: {
      operatorType: {
        serializedName: "operatorType",
        required: true,
        type: {
          name: "String",
        },
      },
      key: {
        serializedName: "key",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const RetryPolicy: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RetryPolicy",
    modelProperties: {
      maxDeliveryAttempts: {
        defaultValue: 30,
        serializedName: "maxDeliveryAttempts",
        type: {
          name: "Number",
        },
      },
      eventTimeToLiveInMinutes: {
        defaultValue: 1440,
        serializedName: "eventTimeToLiveInMinutes",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const EventSubscriptionUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventSubscriptionUpdateParameters",
    modelProperties: {
      destination: {
        serializedName: "destination",
        type: {
          name: "Composite",
          className: "EventSubscriptionDestination",
        },
      },
      deliveryWithResourceIdentity: {
        serializedName: "deliveryWithResourceIdentity",
        type: {
          name: "Composite",
          className: "DeliveryWithResourceIdentity",
        },
      },
      filter: {
        serializedName: "filter",
        type: {
          name: "Composite",
          className: "EventSubscriptionFilter",
        },
      },
      labels: {
        serializedName: "labels",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      expirationTimeUtc: {
        serializedName: "expirationTimeUtc",
        type: {
          name: "DateTime",
        },
      },
      eventDeliverySchema: {
        serializedName: "eventDeliverySchema",
        type: {
          name: "String",
        },
      },
      retryPolicy: {
        serializedName: "retryPolicy",
        type: {
          name: "Composite",
          className: "RetryPolicy",
        },
      },
      deadLetterDestination: {
        serializedName: "deadLetterDestination",
        type: {
          name: "Composite",
          className: "DeadLetterDestination",
        },
      },
      deadLetterWithResourceIdentity: {
        serializedName: "deadLetterWithResourceIdentity",
        type: {
          name: "Composite",
          className: "DeadLetterWithResourceIdentity",
        },
      },
    },
  },
};

export const EventSubscriptionsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventSubscriptionsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EventSubscription",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicsConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicsConfiguration",
    modelProperties: {
      hostname: {
        serializedName: "hostname",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      customDomains: {
        serializedName: "customDomains",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomDomainConfiguration",
            },
          },
        },
      },
    },
  },
};

export const CustomDomainConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomDomainConfiguration",
    modelProperties: {
      fullyQualifiedDomainName: {
        serializedName: "fullyQualifiedDomainName",
        required: true,
        type: {
          name: "String",
        },
      },
      validationState: {
        serializedName: "validationState",
        type: {
          name: "String",
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "CustomDomainIdentity",
        },
      },
      certificateUrl: {
        serializedName: "certificateUrl",
        type: {
          name: "String",
        },
      },
      expectedTxtRecordName: {
        serializedName: "expectedTxtRecordName",
        type: {
          name: "String",
        },
      },
      expectedTxtRecordValue: {
        serializedName: "expectedTxtRecordValue",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CustomDomainIdentity: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CustomDomainIdentity",
    modelProperties: {
      type: {
        serializedName: "type",
        type: {
          name: "String",
        },
      },
      userAssignedIdentity: {
        serializedName: "userAssignedIdentity",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicSpacesConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicSpacesConfiguration",
    modelProperties: {
      state: {
        serializedName: "state",
        type: {
          name: "String",
        },
      },
      routeTopicResourceId: {
        serializedName: "routeTopicResourceId",
        type: {
          name: "String",
        },
      },
      hostname: {
        serializedName: "hostname",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      routingEnrichments: {
        serializedName: "routingEnrichments",
        type: {
          name: "Composite",
          className: "RoutingEnrichments",
        },
      },
      maximumSessionExpiryInHours: {
        serializedName: "maximumSessionExpiryInHours",
        type: {
          name: "Number",
        },
      },
      maximumClientSessionsPerAuthenticationName: {
        serializedName: "maximumClientSessionsPerAuthenticationName",
        type: {
          name: "Number",
        },
      },
      routingIdentityInfo: {
        serializedName: "routingIdentityInfo",
        type: {
          name: "Composite",
          className: "RoutingIdentityInfo",
        },
      },
      customDomains: {
        serializedName: "customDomains",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomDomainConfiguration",
            },
          },
        },
      },
    },
  },
};

export const RoutingEnrichments: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RoutingEnrichments",
    modelProperties: {
      static: {
        serializedName: "static",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "StaticRoutingEnrichment",
            },
          },
        },
      },
      dynamic: {
        serializedName: "dynamic",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DynamicRoutingEnrichment",
            },
          },
        },
      },
    },
  },
};

export const StaticRoutingEnrichment: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "StaticRoutingEnrichment",
    uberParent: "StaticRoutingEnrichment",
    polymorphicDiscriminator: {
      serializedName: "valueType",
      clientName: "valueType",
    },
    modelProperties: {
      key: {
        serializedName: "key",
        type: {
          name: "String",
        },
      },
      valueType: {
        serializedName: "valueType",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DynamicRoutingEnrichment: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DynamicRoutingEnrichment",
    modelProperties: {
      key: {
        serializedName: "key",
        type: {
          name: "String",
        },
      },
      value: {
        serializedName: "value",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const RoutingIdentityInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "RoutingIdentityInfo",
    modelProperties: {
      type: {
        serializedName: "type",
        type: {
          name: "String",
        },
      },
      userAssignedIdentity: {
        serializedName: "userAssignedIdentity",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespaceSku: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceSku",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      capacity: {
        serializedName: "capacity",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const NamespaceUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceUpdateParameters",
    modelProperties: {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
      sku: {
        serializedName: "sku",
        type: {
          name: "Composite",
          className: "NamespaceSku",
        },
      },
      topicSpacesConfiguration: {
        serializedName: "properties.topicSpacesConfiguration",
        type: {
          name: "Composite",
          className: "UpdateTopicSpacesConfigurationInfo",
        },
      },
      topicsConfiguration: {
        serializedName: "properties.topicsConfiguration",
        type: {
          name: "Composite",
          className: "UpdateTopicsConfigurationInfo",
        },
      },
      publicNetworkAccess: {
        serializedName: "properties.publicNetworkAccess",
        type: {
          name: "String",
        },
      },
      inboundIpRules: {
        serializedName: "properties.inboundIpRules",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "InboundIpRule",
            },
          },
        },
      },
    },
  },
};

export const UpdateTopicSpacesConfigurationInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "UpdateTopicSpacesConfigurationInfo",
    modelProperties: {
      state: {
        serializedName: "state",
        type: {
          name: "String",
        },
      },
      routeTopicResourceId: {
        serializedName: "routeTopicResourceId",
        type: {
          name: "String",
        },
      },
      routingEnrichments: {
        serializedName: "routingEnrichments",
        type: {
          name: "Composite",
          className: "RoutingEnrichments",
        },
      },
      maximumSessionExpiryInHours: {
        serializedName: "maximumSessionExpiryInHours",
        type: {
          name: "Number",
        },
      },
      maximumClientSessionsPerAuthenticationName: {
        serializedName: "maximumClientSessionsPerAuthenticationName",
        type: {
          name: "Number",
        },
      },
      routingIdentityInfo: {
        serializedName: "routingIdentityInfo",
        type: {
          name: "Composite",
          className: "RoutingIdentityInfo",
        },
      },
      customDomains: {
        serializedName: "customDomains",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomDomainConfiguration",
            },
          },
        },
      },
    },
  },
};

export const UpdateTopicsConfigurationInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "UpdateTopicsConfigurationInfo",
    modelProperties: {
      customDomains: {
        serializedName: "customDomains",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CustomDomainConfiguration",
            },
          },
        },
      },
    },
  },
};

export const NamespacesListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespacesListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Namespace",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespaceSharedAccessKeys: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceSharedAccessKeys",
    modelProperties: {
      key1: {
        serializedName: "key1",
        type: {
          name: "String",
        },
      },
      key2: {
        serializedName: "key2",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespaceRegenerateKeyRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceRegenerateKeyRequest",
    modelProperties: {
      keyName: {
        serializedName: "keyName",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespaceTopicUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceTopicUpdateParameters",
    modelProperties: {
      eventRetentionInDays: {
        serializedName: "properties.eventRetentionInDays",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const NamespaceTopicsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceTopicsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NamespaceTopic",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicSharedAccessKeys: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicSharedAccessKeys",
    modelProperties: {
      key1: {
        serializedName: "key1",
        type: {
          name: "String",
        },
      },
      key2: {
        serializedName: "key2",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicRegenerateKeyRequest: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicRegenerateKeyRequest",
    modelProperties: {
      keyName: {
        serializedName: "keyName",
        required: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const OperationsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OperationsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Operation",
            },
          },
        },
      },
    },
  },
};

export const Operation: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Operation",
    modelProperties: {
      name: {
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      display: {
        serializedName: "display",
        type: {
          name: "Composite",
          className: "OperationInfo",
        },
      },
      origin: {
        serializedName: "origin",
        type: {
          name: "String",
        },
      },
      isDataAction: {
        serializedName: "isDataAction",
        type: {
          name: "Boolean",
        },
      },
      properties: {
        serializedName: "properties",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
    },
  },
};

export const OperationInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "OperationInfo",
    modelProperties: {
      provider: {
        serializedName: "provider",
        type: {
          name: "String",
        },
      },
      resource: {
        serializedName: "resource",
        type: {
          name: "String",
        },
      },
      operation: {
        serializedName: "operation",
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicUpdateParameters",
    modelProperties: {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
      publicNetworkAccess: {
        serializedName: "properties.publicNetworkAccess",
        type: {
          name: "String",
        },
      },
      inboundIpRules: {
        serializedName: "properties.inboundIpRules",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "InboundIpRule",
            },
          },
        },
      },
      minimumTlsVersionAllowed: {
        serializedName: "properties.minimumTlsVersionAllowed",
        type: {
          name: "String",
        },
      },
      disableLocalAuth: {
        serializedName: "properties.disableLocalAuth",
        type: {
          name: "Boolean",
        },
      },
      dataResidencyBoundary: {
        serializedName: "properties.dataResidencyBoundary",
        type: {
          name: "String",
        },
      },
      eventTypeInfo: {
        serializedName: "properties.eventTypeInfo",
        type: {
          name: "Composite",
          className: "EventTypeInfo",
        },
      },
    },
  },
};

export const TopicsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Topic",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerAuthorization: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerAuthorization",
    modelProperties: {
      defaultMaximumExpirationTimeInDays: {
        serializedName: "defaultMaximumExpirationTimeInDays",
        type: {
          name: "Number",
        },
      },
      authorizedPartnersList: {
        serializedName: "authorizedPartnersList",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Partner",
            },
          },
        },
      },
    },
  },
};

export const Partner: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Partner",
    modelProperties: {
      partnerRegistrationImmutableId: {
        serializedName: "partnerRegistrationImmutableId",
        type: {
          name: "Uuid",
        },
      },
      partnerName: {
        serializedName: "partnerName",
        type: {
          name: "String",
        },
      },
      authorizationExpirationTimeInUtc: {
        serializedName: "authorizationExpirationTimeInUtc",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const PartnerConfigurationUpdateParameters: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "PartnerConfigurationUpdateParameters",
      modelProperties: {
        tags: {
          serializedName: "tags",
          type: {
            name: "Dictionary",
            value: { type: { name: "String" } },
          },
        },
        defaultMaximumExpirationTimeInDays: {
          serializedName: "properties.defaultMaximumExpirationTimeInDays",
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const PartnerConfigurationsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerConfigurationsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PartnerConfiguration",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerNamespaceUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerNamespaceUpdateParameters",
    modelProperties: {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      publicNetworkAccess: {
        serializedName: "properties.publicNetworkAccess",
        type: {
          name: "String",
        },
      },
      inboundIpRules: {
        serializedName: "properties.inboundIpRules",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "InboundIpRule",
            },
          },
        },
      },
      minimumTlsVersionAllowed: {
        serializedName: "properties.minimumTlsVersionAllowed",
        type: {
          name: "String",
        },
      },
      disableLocalAuth: {
        serializedName: "properties.disableLocalAuth",
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const PartnerNamespacesListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerNamespacesListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PartnerNamespace",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerNamespaceSharedAccessKeys: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerNamespaceSharedAccessKeys",
    modelProperties: {
      key1: {
        serializedName: "key1",
        type: {
          name: "String",
        },
      },
      key2: {
        serializedName: "key2",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerNamespaceRegenerateKeyRequest: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "PartnerNamespaceRegenerateKeyRequest",
      modelProperties: {
        keyName: {
          serializedName: "keyName",
          required: true,
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const PartnerRegistrationUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerRegistrationUpdateParameters",
    modelProperties: {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const PartnerRegistrationsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerRegistrationsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PartnerRegistration",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerTopicUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerTopicUpdateParameters",
    modelProperties: {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
    },
  },
};

export const PartnerTopicsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerTopicsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PartnerTopic",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PermissionBindingsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PermissionBindingsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PermissionBinding",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PrivateEndpointConnectionListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PrivateEndpointConnectionListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PrivateEndpointConnection",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PrivateLinkResource: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PrivateLinkResource",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String",
        },
      },
      name: {
        serializedName: "name",
        type: {
          name: "String",
        },
      },
      type: {
        serializedName: "type",
        type: {
          name: "String",
        },
      },
      groupId: {
        serializedName: "properties.groupId",
        type: {
          name: "String",
        },
      },
      displayName: {
        serializedName: "properties.displayName",
        type: {
          name: "String",
        },
      },
      requiredMembers: {
        serializedName: "properties.requiredMembers",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      requiredZoneNames: {
        serializedName: "properties.requiredZoneNames",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const PrivateLinkResourcesListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PrivateLinkResourcesListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PrivateLinkResource",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const SystemTopicUpdateParameters: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SystemTopicUpdateParameters",
    modelProperties: {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
    },
  },
};

export const SystemTopicsListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SystemTopicsListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SystemTopic",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EventTypesListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventTypesListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "EventType",
            },
          },
        },
      },
    },
  },
};

export const TopicSpacesListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicSpacesListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TopicSpace",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicTypesListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicTypesListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TopicTypeInfo",
            },
          },
        },
      },
    },
  },
};

export const TopicTypeAdditionalEnforcedPermission: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "TopicTypeAdditionalEnforcedPermission",
      modelProperties: {
        permissionName: {
          serializedName: "permissionName",
          type: {
            name: "String",
          },
        },
        isDataAction: {
          serializedName: "isDataAction",
          type: {
            name: "Boolean",
          },
        },
      },
    },
  };

export const PartnerDetails: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerDetails",
    modelProperties: {
      description: {
        serializedName: "description",
        type: {
          name: "String",
        },
      },
      longDescription: {
        serializedName: "longDescription",
        type: {
          name: "String",
        },
      },
      setupUri: {
        serializedName: "setupUri",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const VerifiedPartnersListResult: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "VerifiedPartnersListResult",
    modelProperties: {
      value: {
        serializedName: "value",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "VerifiedPartner",
            },
          },
        },
      },
      nextLink: {
        serializedName: "nextLink",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CustomDomainOwnershipValidationResult: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "CustomDomainOwnershipValidationResult",
      modelProperties: {
        customDomainsForTopicsConfiguration: {
          serializedName: "customDomainsForTopicsConfiguration",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "CustomDomainConfiguration",
              },
            },
          },
        },
        customDomainsForTopicSpacesConfiguration: {
          serializedName: "customDomainsForTopicSpacesConfiguration",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "CustomDomainConfiguration",
              },
            },
          },
        },
      },
    },
  };

export const SubscriptionFullUrl: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SubscriptionFullUrl",
    modelProperties: {
      endpointUrl: {
        serializedName: "endpointUrl",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const JsonField: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "JsonField",
    modelProperties: {
      sourceField: {
        serializedName: "sourceField",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const JsonFieldWithDefault: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "JsonFieldWithDefault",
    modelProperties: {
      sourceField: {
        serializedName: "sourceField",
        type: {
          name: "String",
        },
      },
      defaultValue: {
        serializedName: "defaultValue",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CaCertificate: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CaCertificate",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String",
        },
      },
      encodedCertificate: {
        serializedName: "properties.encodedCertificate",
        type: {
          name: "String",
        },
      },
      issueTimeInUtc: {
        serializedName: "properties.issueTimeInUtc",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      expiryTimeInUtc: {
        serializedName: "properties.expiryTimeInUtc",
        readOnly: true,
        type: {
          name: "DateTime",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Channel: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Channel",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      channelType: {
        serializedName: "properties.channelType",
        type: {
          name: "String",
        },
      },
      partnerTopicInfo: {
        serializedName: "properties.partnerTopicInfo",
        type: {
          name: "Composite",
          className: "PartnerTopicInfo",
        },
      },
      messageForActivation: {
        serializedName: "properties.messageForActivation",
        type: {
          name: "String",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        type: {
          name: "String",
        },
      },
      readinessState: {
        serializedName: "properties.readinessState",
        type: {
          name: "String",
        },
      },
      expirationTimeIfNotActivatedUtc: {
        serializedName: "properties.expirationTimeIfNotActivatedUtc",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const ClientGroup: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ClientGroup",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String",
        },
      },
      query: {
        serializedName: "properties.query",
        type: {
          name: "String",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Client: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Client",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String",
        },
      },
      authenticationName: {
        serializedName: "properties.authenticationName",
        type: {
          name: "String",
        },
      },
      clientCertificateAuthentication: {
        serializedName: "properties.clientCertificateAuthentication",
        type: {
          name: "Composite",
          className: "ClientCertificateAuthentication",
        },
      },
      state: {
        defaultValue: "Enabled",
        serializedName: "properties.state",
        type: {
          name: "String",
        },
      },
      attributes: {
        serializedName: "properties.attributes",
        type: {
          name: "Dictionary",
          value: { type: { name: "any" } },
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PrivateEndpointConnection: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PrivateEndpointConnection",
    modelProperties: {
      ...Resource.type.modelProperties,
      privateEndpoint: {
        serializedName: "properties.privateEndpoint",
        type: {
          name: "Composite",
          className: "PrivateEndpoint",
        },
      },
      groupIds: {
        serializedName: "properties.groupIds",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      privateLinkServiceConnectionState: {
        serializedName: "properties.privateLinkServiceConnectionState",
        type: {
          name: "Composite",
          className: "ConnectionState",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TrackedResource: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TrackedResource",
    modelProperties: {
      ...Resource.type.modelProperties,
      location: {
        serializedName: "location",
        required: true,
        type: {
          name: "String",
        },
      },
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const DomainTopic: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DomainTopic",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Subscription: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Subscription",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      deliveryConfiguration: {
        serializedName: "properties.deliveryConfiguration",
        type: {
          name: "Composite",
          className: "DeliveryConfiguration",
        },
      },
      eventDeliverySchema: {
        serializedName: "properties.eventDeliverySchema",
        type: {
          name: "String",
        },
      },
      filtersConfiguration: {
        serializedName: "properties.filtersConfiguration",
        type: {
          name: "Composite",
          className: "FiltersConfiguration",
        },
      },
      expirationTimeUtc: {
        serializedName: "properties.expirationTimeUtc",
        type: {
          name: "DateTime",
        },
      },
    },
  },
};

export const EventSubscription: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventSubscription",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      topic: {
        serializedName: "properties.topic",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      destination: {
        serializedName: "properties.destination",
        type: {
          name: "Composite",
          className: "EventSubscriptionDestination",
        },
      },
      deliveryWithResourceIdentity: {
        serializedName: "properties.deliveryWithResourceIdentity",
        type: {
          name: "Composite",
          className: "DeliveryWithResourceIdentity",
        },
      },
      filter: {
        serializedName: "properties.filter",
        type: {
          name: "Composite",
          className: "EventSubscriptionFilter",
        },
      },
      labels: {
        serializedName: "properties.labels",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      expirationTimeUtc: {
        serializedName: "properties.expirationTimeUtc",
        type: {
          name: "DateTime",
        },
      },
      eventDeliverySchema: {
        serializedName: "properties.eventDeliverySchema",
        type: {
          name: "String",
        },
      },
      retryPolicy: {
        serializedName: "properties.retryPolicy",
        type: {
          name: "Composite",
          className: "RetryPolicy",
        },
      },
      deadLetterDestination: {
        serializedName: "properties.deadLetterDestination",
        type: {
          name: "Composite",
          className: "DeadLetterDestination",
        },
      },
      deadLetterWithResourceIdentity: {
        serializedName: "properties.deadLetterWithResourceIdentity",
        type: {
          name: "Composite",
          className: "DeadLetterWithResourceIdentity",
        },
      },
    },
  },
};

export const NamespaceTopic: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceTopic",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      publisherType: {
        serializedName: "properties.publisherType",
        type: {
          name: "String",
        },
      },
      inputSchema: {
        defaultValue: "CloudEventSchemaV1_0",
        serializedName: "properties.inputSchema",
        type: {
          name: "String",
        },
      },
      eventRetentionInDays: {
        serializedName: "properties.eventRetentionInDays",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const PartnerConfiguration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerConfiguration",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      partnerAuthorization: {
        serializedName: "properties.partnerAuthorization",
        type: {
          name: "Composite",
          className: "PartnerAuthorization",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PermissionBinding: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PermissionBinding",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String",
        },
      },
      topicSpaceName: {
        serializedName: "properties.topicSpaceName",
        type: {
          name: "String",
        },
      },
      permission: {
        serializedName: "properties.permission",
        type: {
          name: "String",
        },
      },
      clientGroupName: {
        serializedName: "properties.clientGroupName",
        type: {
          name: "String",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EventType: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventType",
    modelProperties: {
      ...Resource.type.modelProperties,
      displayName: {
        serializedName: "properties.displayName",
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String",
        },
      },
      schemaUrl: {
        serializedName: "properties.schemaUrl",
        type: {
          name: "String",
        },
      },
      isInDefaultSet: {
        serializedName: "properties.isInDefaultSet",
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const ExtensionTopic: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ExtensionTopic",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String",
        },
      },
      systemTopic: {
        serializedName: "properties.systemTopic",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicSpace: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicSpace",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String",
        },
      },
      topicTemplates: {
        serializedName: "properties.topicTemplates",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicTypeInfo: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicTypeInfo",
    modelProperties: {
      ...Resource.type.modelProperties,
      provider: {
        serializedName: "properties.provider",
        type: {
          name: "String",
        },
      },
      displayName: {
        serializedName: "properties.displayName",
        type: {
          name: "String",
        },
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String",
        },
      },
      resourceRegionType: {
        serializedName: "properties.resourceRegionType",
        type: {
          name: "String",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        type: {
          name: "String",
        },
      },
      supportedLocations: {
        serializedName: "properties.supportedLocations",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      sourceResourceFormat: {
        serializedName: "properties.sourceResourceFormat",
        type: {
          name: "String",
        },
      },
      supportedScopesForSource: {
        serializedName: "properties.supportedScopesForSource",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
      areRegionalAndGlobalSourcesSupported: {
        serializedName: "properties.areRegionalAndGlobalSourcesSupported",
        type: {
          name: "Boolean",
        },
      },
      additionalEnforcedPermissions: {
        serializedName: "properties.additionalEnforcedPermissions",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "TopicTypeAdditionalEnforcedPermission",
            },
          },
        },
      },
    },
  },
};

export const VerifiedPartner: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "VerifiedPartner",
    modelProperties: {
      ...Resource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      partnerRegistrationImmutableId: {
        serializedName: "properties.partnerRegistrationImmutableId",
        type: {
          name: "Uuid",
        },
      },
      organizationName: {
        serializedName: "properties.organizationName",
        type: {
          name: "String",
        },
      },
      partnerDisplayName: {
        serializedName: "properties.partnerDisplayName",
        type: {
          name: "String",
        },
      },
      partnerTopicDetails: {
        serializedName: "properties.partnerTopicDetails",
        type: {
          name: "Composite",
          className: "PartnerDetails",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const JsonInputSchemaMapping: coreClient.CompositeMapper = {
  serializedName: "Json",
  type: {
    name: "Composite",
    className: "JsonInputSchemaMapping",
    uberParent: "InputSchemaMapping",
    polymorphicDiscriminator: InputSchemaMapping.type.polymorphicDiscriminator,
    modelProperties: {
      ...InputSchemaMapping.type.modelProperties,
      id: {
        serializedName: "properties.id",
        type: {
          name: "Composite",
          className: "JsonField",
        },
      },
      topic: {
        serializedName: "properties.topic",
        type: {
          name: "Composite",
          className: "JsonField",
        },
      },
      eventTime: {
        serializedName: "properties.eventTime",
        type: {
          name: "Composite",
          className: "JsonField",
        },
      },
      eventType: {
        serializedName: "properties.eventType",
        type: {
          name: "Composite",
          className: "JsonFieldWithDefault",
        },
      },
      subject: {
        serializedName: "properties.subject",
        type: {
          name: "Composite",
          className: "JsonFieldWithDefault",
        },
      },
      dataVersion: {
        serializedName: "properties.dataVersion",
        type: {
          name: "Composite",
          className: "JsonFieldWithDefault",
        },
      },
    },
  },
};

export const StaticDeliveryAttributeMapping: coreClient.CompositeMapper = {
  serializedName: "Static",
  type: {
    name: "Composite",
    className: "StaticDeliveryAttributeMapping",
    uberParent: "DeliveryAttributeMapping",
    polymorphicDiscriminator:
      DeliveryAttributeMapping.type.polymorphicDiscriminator,
    modelProperties: {
      ...DeliveryAttributeMapping.type.modelProperties,
      value: {
        serializedName: "properties.value",
        type: {
          name: "String",
        },
      },
      isSecret: {
        defaultValue: false,
        serializedName: "properties.isSecret",
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const DynamicDeliveryAttributeMapping: coreClient.CompositeMapper = {
  serializedName: "Dynamic",
  type: {
    name: "Composite",
    className: "DynamicDeliveryAttributeMapping",
    uberParent: "DeliveryAttributeMapping",
    polymorphicDiscriminator:
      DeliveryAttributeMapping.type.polymorphicDiscriminator,
    modelProperties: {
      ...DeliveryAttributeMapping.type.modelProperties,
      sourceField: {
        serializedName: "properties.sourceField",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const StorageBlobDeadLetterDestination: coreClient.CompositeMapper = {
  serializedName: "StorageBlob",
  type: {
    name: "Composite",
    className: "StorageBlobDeadLetterDestination",
    uberParent: "DeadLetterDestination",
    polymorphicDiscriminator:
      DeadLetterDestination.type.polymorphicDiscriminator,
    modelProperties: {
      ...DeadLetterDestination.type.modelProperties,
      resourceId: {
        serializedName: "properties.resourceId",
        type: {
          name: "String",
        },
      },
      blobContainerName: {
        serializedName: "properties.blobContainerName",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const WebHookEventSubscriptionDestination: coreClient.CompositeMapper = {
  serializedName: "WebHook",
  type: {
    name: "Composite",
    className: "WebHookEventSubscriptionDestination",
    uberParent: "EventSubscriptionDestination",
    polymorphicDiscriminator:
      EventSubscriptionDestination.type.polymorphicDiscriminator,
    modelProperties: {
      ...EventSubscriptionDestination.type.modelProperties,
      endpointUrl: {
        serializedName: "properties.endpointUrl",
        type: {
          name: "String",
        },
      },
      endpointBaseUrl: {
        serializedName: "properties.endpointBaseUrl",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      maxEventsPerBatch: {
        defaultValue: 1,
        serializedName: "properties.maxEventsPerBatch",
        type: {
          name: "Number",
        },
      },
      preferredBatchSizeInKilobytes: {
        defaultValue: 64,
        serializedName: "properties.preferredBatchSizeInKilobytes",
        type: {
          name: "Number",
        },
      },
      azureActiveDirectoryTenantId: {
        serializedName: "properties.azureActiveDirectoryTenantId",
        type: {
          name: "String",
        },
      },
      azureActiveDirectoryApplicationIdOrUri: {
        serializedName: "properties.azureActiveDirectoryApplicationIdOrUri",
        type: {
          name: "String",
        },
      },
      deliveryAttributeMappings: {
        serializedName: "properties.deliveryAttributeMappings",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "DeliveryAttributeMapping",
            },
          },
        },
      },
      minimumTlsVersionAllowed: {
        serializedName: "properties.minimumTlsVersionAllowed",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EventHubEventSubscriptionDestination: coreClient.CompositeMapper =
  {
    serializedName: "EventHub",
    type: {
      name: "Composite",
      className: "EventHubEventSubscriptionDestination",
      uberParent: "EventSubscriptionDestination",
      polymorphicDiscriminator:
        EventSubscriptionDestination.type.polymorphicDiscriminator,
      modelProperties: {
        ...EventSubscriptionDestination.type.modelProperties,
        resourceId: {
          serializedName: "properties.resourceId",
          type: {
            name: "String",
          },
        },
        deliveryAttributeMappings: {
          serializedName: "properties.deliveryAttributeMappings",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "DeliveryAttributeMapping",
              },
            },
          },
        },
      },
    },
  };

export const StorageQueueEventSubscriptionDestination: coreClient.CompositeMapper =
  {
    serializedName: "StorageQueue",
    type: {
      name: "Composite",
      className: "StorageQueueEventSubscriptionDestination",
      uberParent: "EventSubscriptionDestination",
      polymorphicDiscriminator:
        EventSubscriptionDestination.type.polymorphicDiscriminator,
      modelProperties: {
        ...EventSubscriptionDestination.type.modelProperties,
        resourceId: {
          serializedName: "properties.resourceId",
          type: {
            name: "String",
          },
        },
        queueName: {
          serializedName: "properties.queueName",
          type: {
            name: "String",
          },
        },
        queueMessageTimeToLiveInSeconds: {
          serializedName: "properties.queueMessageTimeToLiveInSeconds",
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const HybridConnectionEventSubscriptionDestination: coreClient.CompositeMapper =
  {
    serializedName: "HybridConnection",
    type: {
      name: "Composite",
      className: "HybridConnectionEventSubscriptionDestination",
      uberParent: "EventSubscriptionDestination",
      polymorphicDiscriminator:
        EventSubscriptionDestination.type.polymorphicDiscriminator,
      modelProperties: {
        ...EventSubscriptionDestination.type.modelProperties,
        resourceId: {
          serializedName: "properties.resourceId",
          type: {
            name: "String",
          },
        },
        deliveryAttributeMappings: {
          serializedName: "properties.deliveryAttributeMappings",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "DeliveryAttributeMapping",
              },
            },
          },
        },
      },
    },
  };

export const ServiceBusQueueEventSubscriptionDestination: coreClient.CompositeMapper =
  {
    serializedName: "ServiceBusQueue",
    type: {
      name: "Composite",
      className: "ServiceBusQueueEventSubscriptionDestination",
      uberParent: "EventSubscriptionDestination",
      polymorphicDiscriminator:
        EventSubscriptionDestination.type.polymorphicDiscriminator,
      modelProperties: {
        ...EventSubscriptionDestination.type.modelProperties,
        resourceId: {
          serializedName: "properties.resourceId",
          type: {
            name: "String",
          },
        },
        deliveryAttributeMappings: {
          serializedName: "properties.deliveryAttributeMappings",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "DeliveryAttributeMapping",
              },
            },
          },
        },
      },
    },
  };

export const ServiceBusTopicEventSubscriptionDestination: coreClient.CompositeMapper =
  {
    serializedName: "ServiceBusTopic",
    type: {
      name: "Composite",
      className: "ServiceBusTopicEventSubscriptionDestination",
      uberParent: "EventSubscriptionDestination",
      polymorphicDiscriminator:
        EventSubscriptionDestination.type.polymorphicDiscriminator,
      modelProperties: {
        ...EventSubscriptionDestination.type.modelProperties,
        resourceId: {
          serializedName: "properties.resourceId",
          type: {
            name: "String",
          },
        },
        deliveryAttributeMappings: {
          serializedName: "properties.deliveryAttributeMappings",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "DeliveryAttributeMapping",
              },
            },
          },
        },
      },
    },
  };

export const AzureFunctionEventSubscriptionDestination: coreClient.CompositeMapper =
  {
    serializedName: "AzureFunction",
    type: {
      name: "Composite",
      className: "AzureFunctionEventSubscriptionDestination",
      uberParent: "EventSubscriptionDestination",
      polymorphicDiscriminator:
        EventSubscriptionDestination.type.polymorphicDiscriminator,
      modelProperties: {
        ...EventSubscriptionDestination.type.modelProperties,
        resourceId: {
          serializedName: "properties.resourceId",
          type: {
            name: "String",
          },
        },
        maxEventsPerBatch: {
          defaultValue: 1,
          serializedName: "properties.maxEventsPerBatch",
          type: {
            name: "Number",
          },
        },
        preferredBatchSizeInKilobytes: {
          defaultValue: 64,
          serializedName: "properties.preferredBatchSizeInKilobytes",
          type: {
            name: "Number",
          },
        },
        deliveryAttributeMappings: {
          serializedName: "properties.deliveryAttributeMappings",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "Composite",
                className: "DeliveryAttributeMapping",
              },
            },
          },
        },
      },
    },
  };

export const MonitorAlertEventSubscriptionDestination: coreClient.CompositeMapper =
  {
    serializedName: "MonitorAlert",
    type: {
      name: "Composite",
      className: "MonitorAlertEventSubscriptionDestination",
      uberParent: "EventSubscriptionDestination",
      polymorphicDiscriminator:
        EventSubscriptionDestination.type.polymorphicDiscriminator,
      modelProperties: {
        ...EventSubscriptionDestination.type.modelProperties,
        severity: {
          serializedName: "properties.severity",
          type: {
            name: "String",
          },
        },
        description: {
          serializedName: "properties.description",
          type: {
            name: "String",
          },
        },
        actionGroups: {
          serializedName: "properties.actionGroups",
          type: {
            name: "Sequence",
            element: {
              type: {
                name: "String",
              },
            },
          },
        },
      },
    },
  };

export const NamespaceTopicEventSubscriptionDestination: coreClient.CompositeMapper =
  {
    serializedName: "NamespaceTopic",
    type: {
      name: "Composite",
      className: "NamespaceTopicEventSubscriptionDestination",
      uberParent: "EventSubscriptionDestination",
      polymorphicDiscriminator:
        EventSubscriptionDestination.type.polymorphicDiscriminator,
      modelProperties: {
        ...EventSubscriptionDestination.type.modelProperties,
        resourceId: {
          serializedName: "properties.resourceId",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const NumberInFilter: coreClient.CompositeMapper = {
  serializedName: "NumberIn",
  type: {
    name: "Composite",
    className: "NumberInFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Number",
            },
          },
        },
      },
    },
  },
};

export const NumberNotInFilter: coreClient.CompositeMapper = {
  serializedName: "NumberNotIn",
  type: {
    name: "Composite",
    className: "NumberNotInFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Number",
            },
          },
        },
      },
    },
  },
};

export const NumberLessThanFilter: coreClient.CompositeMapper = {
  serializedName: "NumberLessThan",
  type: {
    name: "Composite",
    className: "NumberLessThanFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const NumberGreaterThanFilter: coreClient.CompositeMapper = {
  serializedName: "NumberGreaterThan",
  type: {
    name: "Composite",
    className: "NumberGreaterThanFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const NumberLessThanOrEqualsFilter: coreClient.CompositeMapper = {
  serializedName: "NumberLessThanOrEquals",
  type: {
    name: "Composite",
    className: "NumberLessThanOrEqualsFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const NumberGreaterThanOrEqualsFilter: coreClient.CompositeMapper = {
  serializedName: "NumberGreaterThanOrEquals",
  type: {
    name: "Composite",
    className: "NumberGreaterThanOrEqualsFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const BoolEqualsFilter: coreClient.CompositeMapper = {
  serializedName: "BoolEquals",
  type: {
    name: "Composite",
    className: "BoolEqualsFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const StringInFilter: coreClient.CompositeMapper = {
  serializedName: "StringIn",
  type: {
    name: "Composite",
    className: "StringInFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringNotInFilter: coreClient.CompositeMapper = {
  serializedName: "StringNotIn",
  type: {
    name: "Composite",
    className: "StringNotInFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringBeginsWithFilter: coreClient.CompositeMapper = {
  serializedName: "StringBeginsWith",
  type: {
    name: "Composite",
    className: "StringBeginsWithFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringEndsWithFilter: coreClient.CompositeMapper = {
  serializedName: "StringEndsWith",
  type: {
    name: "Composite",
    className: "StringEndsWithFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringContainsFilter: coreClient.CompositeMapper = {
  serializedName: "StringContains",
  type: {
    name: "Composite",
    className: "StringContainsFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const NumberInRangeFilter: coreClient.CompositeMapper = {
  serializedName: "NumberInRange",
  type: {
    name: "Composite",
    className: "NumberInRangeFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Sequence",
              element: {
                type: {
                  name: "Number",
                },
              },
            },
          },
        },
      },
    },
  },
};

export const NumberNotInRangeFilter: coreClient.CompositeMapper = {
  serializedName: "NumberNotInRange",
  type: {
    name: "Composite",
    className: "NumberNotInRangeFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Sequence",
              element: {
                type: {
                  name: "Number",
                },
              },
            },
          },
        },
      },
    },
  },
};

export const StringNotBeginsWithFilter: coreClient.CompositeMapper = {
  serializedName: "StringNotBeginsWith",
  type: {
    name: "Composite",
    className: "StringNotBeginsWithFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringNotEndsWithFilter: coreClient.CompositeMapper = {
  serializedName: "StringNotEndsWith",
  type: {
    name: "Composite",
    className: "StringNotEndsWithFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringNotContainsFilter: coreClient.CompositeMapper = {
  serializedName: "StringNotContains",
  type: {
    name: "Composite",
    className: "StringNotContainsFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const IsNullOrUndefinedFilter: coreClient.CompositeMapper = {
  serializedName: "IsNullOrUndefined",
  type: {
    name: "Composite",
    className: "IsNullOrUndefinedFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
    },
  },
};

export const IsNotNullFilter: coreClient.CompositeMapper = {
  serializedName: "IsNotNull",
  type: {
    name: "Composite",
    className: "IsNotNullFilter",
    uberParent: "Filter",
    polymorphicDiscriminator: Filter.type.polymorphicDiscriminator,
    modelProperties: {
      ...Filter.type.modelProperties,
    },
  },
};

export const NumberInAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "NumberIn",
  type: {
    name: "Composite",
    className: "NumberInAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Number",
            },
          },
        },
      },
    },
  },
};

export const NumberNotInAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "NumberNotIn",
  type: {
    name: "Composite",
    className: "NumberNotInAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Number",
            },
          },
        },
      },
    },
  },
};

export const NumberLessThanAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "NumberLessThan",
  type: {
    name: "Composite",
    className: "NumberLessThanAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const NumberGreaterThanAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "NumberGreaterThan",
  type: {
    name: "Composite",
    className: "NumberGreaterThanAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const NumberLessThanOrEqualsAdvancedFilter: coreClient.CompositeMapper =
  {
    serializedName: "NumberLessThanOrEquals",
    type: {
      name: "Composite",
      className: "NumberLessThanOrEqualsAdvancedFilter",
      uberParent: "AdvancedFilter",
      polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
      modelProperties: {
        ...AdvancedFilter.type.modelProperties,
        value: {
          serializedName: "value",
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const NumberGreaterThanOrEqualsAdvancedFilter: coreClient.CompositeMapper =
  {
    serializedName: "NumberGreaterThanOrEquals",
    type: {
      name: "Composite",
      className: "NumberGreaterThanOrEqualsAdvancedFilter",
      uberParent: "AdvancedFilter",
      polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
      modelProperties: {
        ...AdvancedFilter.type.modelProperties,
        value: {
          serializedName: "value",
          type: {
            name: "Number",
          },
        },
      },
    },
  };

export const BoolEqualsAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "BoolEquals",
  type: {
    name: "Composite",
    className: "BoolEqualsAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "Boolean",
        },
      },
    },
  },
};

export const StringInAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "StringIn",
  type: {
    name: "Composite",
    className: "StringInAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringNotInAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "StringNotIn",
  type: {
    name: "Composite",
    className: "StringNotInAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringBeginsWithAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "StringBeginsWith",
  type: {
    name: "Composite",
    className: "StringBeginsWithAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringEndsWithAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "StringEndsWith",
  type: {
    name: "Composite",
    className: "StringEndsWithAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringContainsAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "StringContains",
  type: {
    name: "Composite",
    className: "StringContainsAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const NumberInRangeAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "NumberInRange",
  type: {
    name: "Composite",
    className: "NumberInRangeAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Sequence",
              element: {
                type: {
                  name: "Number",
                },
              },
            },
          },
        },
      },
    },
  },
};

export const NumberNotInRangeAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "NumberNotInRange",
  type: {
    name: "Composite",
    className: "NumberNotInRangeAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Sequence",
              element: {
                type: {
                  name: "Number",
                },
              },
            },
          },
        },
      },
    },
  },
};

export const StringNotBeginsWithAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "StringNotBeginsWith",
  type: {
    name: "Composite",
    className: "StringNotBeginsWithAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringNotEndsWithAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "StringNotEndsWith",
  type: {
    name: "Composite",
    className: "StringNotEndsWithAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const StringNotContainsAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "StringNotContains",
  type: {
    name: "Composite",
    className: "StringNotContainsAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
      values: {
        serializedName: "values",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String",
            },
          },
        },
      },
    },
  },
};

export const IsNullOrUndefinedAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "IsNullOrUndefined",
  type: {
    name: "Composite",
    className: "IsNullOrUndefinedAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
    },
  },
};

export const IsNotNullAdvancedFilter: coreClient.CompositeMapper = {
  serializedName: "IsNotNull",
  type: {
    name: "Composite",
    className: "IsNotNullAdvancedFilter",
    uberParent: "AdvancedFilter",
    polymorphicDiscriminator: AdvancedFilter.type.polymorphicDiscriminator,
    modelProperties: {
      ...AdvancedFilter.type.modelProperties,
    },
  },
};

export const StaticStringRoutingEnrichment: coreClient.CompositeMapper = {
  serializedName: "String",
  type: {
    name: "Composite",
    className: "StaticStringRoutingEnrichment",
    uberParent: "StaticRoutingEnrichment",
    polymorphicDiscriminator:
      StaticRoutingEnrichment.type.polymorphicDiscriminator,
    modelProperties: {
      ...StaticRoutingEnrichment.type.modelProperties,
      value: {
        serializedName: "value",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Domain: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Domain",
    modelProperties: {
      ...TrackedResource.type.modelProperties,
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      privateEndpointConnections: {
        serializedName: "properties.privateEndpointConnections",
        readOnly: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PrivateEndpointConnection",
            },
          },
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      minimumTlsVersionAllowed: {
        serializedName: "properties.minimumTlsVersionAllowed",
        type: {
          name: "String",
        },
      },
      endpoint: {
        serializedName: "properties.endpoint",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      inputSchema: {
        serializedName: "properties.inputSchema",
        type: {
          name: "String",
        },
      },
      eventTypeInfo: {
        serializedName: "properties.eventTypeInfo",
        type: {
          name: "Composite",
          className: "EventTypeInfo",
        },
      },
      inputSchemaMapping: {
        serializedName: "properties.inputSchemaMapping",
        type: {
          name: "Composite",
          className: "InputSchemaMapping",
        },
      },
      metricResourceId: {
        serializedName: "properties.metricResourceId",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      publicNetworkAccess: {
        serializedName: "properties.publicNetworkAccess",
        type: {
          name: "String",
        },
      },
      inboundIpRules: {
        serializedName: "properties.inboundIpRules",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "InboundIpRule",
            },
          },
        },
      },
      disableLocalAuth: {
        defaultValue: false,
        serializedName: "properties.disableLocalAuth",
        type: {
          name: "Boolean",
        },
      },
      autoCreateTopicWithFirstSubscription: {
        defaultValue: true,
        serializedName: "properties.autoCreateTopicWithFirstSubscription",
        type: {
          name: "Boolean",
        },
      },
      autoDeleteTopicWithLastSubscription: {
        defaultValue: true,
        serializedName: "properties.autoDeleteTopicWithLastSubscription",
        type: {
          name: "Boolean",
        },
      },
      dataResidencyBoundary: {
        serializedName: "properties.dataResidencyBoundary",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Namespace: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Namespace",
    modelProperties: {
      ...TrackedResource.type.modelProperties,
      sku: {
        serializedName: "sku",
        type: {
          name: "Composite",
          className: "NamespaceSku",
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      privateEndpointConnections: {
        serializedName: "properties.privateEndpointConnections",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PrivateEndpointConnection",
            },
          },
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      topicsConfiguration: {
        serializedName: "properties.topicsConfiguration",
        type: {
          name: "Composite",
          className: "TopicsConfiguration",
        },
      },
      topicSpacesConfiguration: {
        serializedName: "properties.topicSpacesConfiguration",
        type: {
          name: "Composite",
          className: "TopicSpacesConfiguration",
        },
      },
      isZoneRedundant: {
        serializedName: "properties.isZoneRedundant",
        type: {
          name: "Boolean",
        },
      },
      publicNetworkAccess: {
        serializedName: "properties.publicNetworkAccess",
        type: {
          name: "String",
        },
      },
      inboundIpRules: {
        serializedName: "properties.inboundIpRules",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "InboundIpRule",
            },
          },
        },
      },
      minimumTlsVersionAllowed: {
        serializedName: "properties.minimumTlsVersionAllowed",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const Topic: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "Topic",
    modelProperties: {
      ...TrackedResource.type.modelProperties,
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      privateEndpointConnections: {
        serializedName: "properties.privateEndpointConnections",
        readOnly: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PrivateEndpointConnection",
            },
          },
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      endpoint: {
        serializedName: "properties.endpoint",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      eventTypeInfo: {
        serializedName: "properties.eventTypeInfo",
        type: {
          name: "Composite",
          className: "EventTypeInfo",
        },
      },
      minimumTlsVersionAllowed: {
        serializedName: "properties.minimumTlsVersionAllowed",
        type: {
          name: "String",
        },
      },
      inputSchema: {
        serializedName: "properties.inputSchema",
        type: {
          name: "String",
        },
      },
      inputSchemaMapping: {
        serializedName: "properties.inputSchemaMapping",
        type: {
          name: "Composite",
          className: "InputSchemaMapping",
        },
      },
      metricResourceId: {
        serializedName: "properties.metricResourceId",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      publicNetworkAccess: {
        serializedName: "properties.publicNetworkAccess",
        type: {
          name: "String",
        },
      },
      inboundIpRules: {
        serializedName: "properties.inboundIpRules",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "InboundIpRule",
            },
          },
        },
      },
      disableLocalAuth: {
        defaultValue: false,
        serializedName: "properties.disableLocalAuth",
        type: {
          name: "Boolean",
        },
      },
      dataResidencyBoundary: {
        serializedName: "properties.dataResidencyBoundary",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerNamespace: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerNamespace",
    modelProperties: {
      ...TrackedResource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      privateEndpointConnections: {
        serializedName: "properties.privateEndpointConnections",
        readOnly: true,
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PrivateEndpointConnection",
            },
          },
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      partnerRegistrationFullyQualifiedId: {
        serializedName: "properties.partnerRegistrationFullyQualifiedId",
        type: {
          name: "String",
        },
      },
      minimumTlsVersionAllowed: {
        serializedName: "properties.minimumTlsVersionAllowed",
        type: {
          name: "String",
        },
      },
      endpoint: {
        serializedName: "properties.endpoint",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      publicNetworkAccess: {
        serializedName: "properties.publicNetworkAccess",
        type: {
          name: "String",
        },
      },
      inboundIpRules: {
        serializedName: "properties.inboundIpRules",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "InboundIpRule",
            },
          },
        },
      },
      disableLocalAuth: {
        defaultValue: false,
        serializedName: "properties.disableLocalAuth",
        type: {
          name: "Boolean",
        },
      },
      partnerTopicRoutingMode: {
        defaultValue: "SourceEventAttribute",
        serializedName: "properties.partnerTopicRoutingMode",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerRegistration: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerRegistration",
    modelProperties: {
      ...TrackedResource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      partnerRegistrationImmutableId: {
        serializedName: "properties.partnerRegistrationImmutableId",
        type: {
          name: "Uuid",
        },
      },
    },
  },
};

export const PartnerTopic: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerTopic",
    modelProperties: {
      ...TrackedResource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
      partnerRegistrationImmutableId: {
        serializedName: "properties.partnerRegistrationImmutableId",
        type: {
          name: "Uuid",
        },
      },
      source: {
        serializedName: "properties.source",
        type: {
          name: "String",
        },
      },
      eventTypeInfo: {
        serializedName: "properties.eventTypeInfo",
        type: {
          name: "Composite",
          className: "EventTypeInfo",
        },
      },
      expirationTimeIfNotActivatedUtc: {
        serializedName: "properties.expirationTimeIfNotActivatedUtc",
        type: {
          name: "DateTime",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      activationState: {
        serializedName: "properties.activationState",
        type: {
          name: "String",
        },
      },
      partnerTopicFriendlyDescription: {
        serializedName: "properties.partnerTopicFriendlyDescription",
        type: {
          name: "String",
        },
      },
      messageForActivation: {
        serializedName: "properties.messageForActivation",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const SystemTopic: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SystemTopic",
    modelProperties: {
      ...TrackedResource.type.modelProperties,
      systemData: {
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData",
        },
      },
      identity: {
        serializedName: "identity",
        type: {
          name: "Composite",
          className: "IdentityInfo",
        },
      },
      provisioningState: {
        serializedName: "properties.provisioningState",
        readOnly: true,
        type: {
          name: "String",
        },
      },
      source: {
        serializedName: "properties.source",
        type: {
          name: "String",
        },
      },
      topicType: {
        serializedName: "properties.topicType",
        type: {
          name: "String",
        },
      },
      metricResourceId: {
        serializedName: "properties.metricResourceId",
        readOnly: true,
        type: {
          name: "String",
        },
      },
    },
  },
};

export const CaCertificatesDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "CaCertificatesDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ChannelsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ChannelsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ClientGroupsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ClientGroupsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ClientsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "ClientsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DomainsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DomainsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DomainTopicsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "DomainTopicsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicEventSubscriptionsDeleteHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "TopicEventSubscriptionsDeleteHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const DomainEventSubscriptionsDeleteHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DomainEventSubscriptionsDeleteHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const NamespaceTopicEventSubscriptionsDeleteHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "NamespaceTopicEventSubscriptionsDeleteHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const NamespaceTopicEventSubscriptionsUpdateHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "NamespaceTopicEventSubscriptionsUpdateHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const EventSubscriptionsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "EventSubscriptionsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DomainTopicEventSubscriptionsDeleteHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "DomainTopicEventSubscriptionsDeleteHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const SystemTopicEventSubscriptionsDeleteHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "SystemTopicEventSubscriptionsDeleteHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const PartnerTopicEventSubscriptionsDeleteHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "PartnerTopicEventSubscriptionsDeleteHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const NamespacesDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespacesDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespacesUpdateHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespacesUpdateHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespacesRegenerateKeyHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespacesRegenerateKeyHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespacesValidateCustomDomainOwnershipHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "NamespacesValidateCustomDomainOwnershipHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const NamespaceTopicsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceTopicsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespaceTopicsUpdateHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceTopicsUpdateHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const NamespaceTopicsRegenerateKeyHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "NamespaceTopicsRegenerateKeyHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicsRegenerateKeyHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicsRegenerateKeyHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerConfigurationsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerConfigurationsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerNamespacesDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerNamespacesDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerRegistrationsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerRegistrationsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PartnerTopicsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PartnerTopicsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PermissionBindingsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "PermissionBindingsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const PrivateEndpointConnectionsDeleteHeaders: coreClient.CompositeMapper =
  {
    type: {
      name: "Composite",
      className: "PrivateEndpointConnectionsDeleteHeaders",
      modelProperties: {
        location: {
          serializedName: "location",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const SystemTopicsDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "SystemTopicsDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const TopicSpacesDeleteHeaders: coreClient.CompositeMapper = {
  type: {
    name: "Composite",
    className: "TopicSpacesDeleteHeaders",
    modelProperties: {
      location: {
        serializedName: "location",
        type: {
          name: "String",
        },
      },
    },
  },
};

export let discriminators = {
  InputSchemaMapping: InputSchemaMapping,
  DeliveryAttributeMapping: DeliveryAttributeMapping,
  DeadLetterDestination: DeadLetterDestination,
  EventSubscriptionDestination: EventSubscriptionDestination,
  Filter: Filter,
  AdvancedFilter: AdvancedFilter,
  StaticRoutingEnrichment: StaticRoutingEnrichment,
  "InputSchemaMapping.Json": JsonInputSchemaMapping,
  "DeliveryAttributeMapping.Static": StaticDeliveryAttributeMapping,
  "DeliveryAttributeMapping.Dynamic": DynamicDeliveryAttributeMapping,
  "DeadLetterDestination.StorageBlob": StorageBlobDeadLetterDestination,
  "EventSubscriptionDestination.WebHook": WebHookEventSubscriptionDestination,
  "EventSubscriptionDestination.EventHub": EventHubEventSubscriptionDestination,
  "EventSubscriptionDestination.StorageQueue":
    StorageQueueEventSubscriptionDestination,
  "EventSubscriptionDestination.HybridConnection":
    HybridConnectionEventSubscriptionDestination,
  "EventSubscriptionDestination.ServiceBusQueue":
    ServiceBusQueueEventSubscriptionDestination,
  "EventSubscriptionDestination.ServiceBusTopic":
    ServiceBusTopicEventSubscriptionDestination,
  "EventSubscriptionDestination.AzureFunction":
    AzureFunctionEventSubscriptionDestination,
  "EventSubscriptionDestination.MonitorAlert":
    MonitorAlertEventSubscriptionDestination,
  "EventSubscriptionDestination.NamespaceTopic":
    NamespaceTopicEventSubscriptionDestination,
  "Filter.NumberIn": NumberInFilter,
  "Filter.NumberNotIn": NumberNotInFilter,
  "Filter.NumberLessThan": NumberLessThanFilter,
  "Filter.NumberGreaterThan": NumberGreaterThanFilter,
  "Filter.NumberLessThanOrEquals": NumberLessThanOrEqualsFilter,
  "Filter.NumberGreaterThanOrEquals": NumberGreaterThanOrEqualsFilter,
  "Filter.BoolEquals": BoolEqualsFilter,
  "Filter.StringIn": StringInFilter,
  "Filter.StringNotIn": StringNotInFilter,
  "Filter.StringBeginsWith": StringBeginsWithFilter,
  "Filter.StringEndsWith": StringEndsWithFilter,
  "Filter.StringContains": StringContainsFilter,
  "Filter.NumberInRange": NumberInRangeFilter,
  "Filter.NumberNotInRange": NumberNotInRangeFilter,
  "Filter.StringNotBeginsWith": StringNotBeginsWithFilter,
  "Filter.StringNotEndsWith": StringNotEndsWithFilter,
  "Filter.StringNotContains": StringNotContainsFilter,
  "Filter.IsNullOrUndefined": IsNullOrUndefinedFilter,
  "Filter.IsNotNull": IsNotNullFilter,
  "AdvancedFilter.NumberIn": NumberInAdvancedFilter,
  "AdvancedFilter.NumberNotIn": NumberNotInAdvancedFilter,
  "AdvancedFilter.NumberLessThan": NumberLessThanAdvancedFilter,
  "AdvancedFilter.NumberGreaterThan": NumberGreaterThanAdvancedFilter,
  "AdvancedFilter.NumberLessThanOrEquals": NumberLessThanOrEqualsAdvancedFilter,
  "AdvancedFilter.NumberGreaterThanOrEquals":
    NumberGreaterThanOrEqualsAdvancedFilter,
  "AdvancedFilter.BoolEquals": BoolEqualsAdvancedFilter,
  "AdvancedFilter.StringIn": StringInAdvancedFilter,
  "AdvancedFilter.StringNotIn": StringNotInAdvancedFilter,
  "AdvancedFilter.StringBeginsWith": StringBeginsWithAdvancedFilter,
  "AdvancedFilter.StringEndsWith": StringEndsWithAdvancedFilter,
  "AdvancedFilter.StringContains": StringContainsAdvancedFilter,
  "AdvancedFilter.NumberInRange": NumberInRangeAdvancedFilter,
  "AdvancedFilter.NumberNotInRange": NumberNotInRangeAdvancedFilter,
  "AdvancedFilter.StringNotBeginsWith": StringNotBeginsWithAdvancedFilter,
  "AdvancedFilter.StringNotEndsWith": StringNotEndsWithAdvancedFilter,
  "AdvancedFilter.StringNotContains": StringNotContainsAdvancedFilter,
  "AdvancedFilter.IsNullOrUndefined": IsNullOrUndefinedAdvancedFilter,
  "AdvancedFilter.IsNotNull": IsNotNullAdvancedFilter,
  "StaticRoutingEnrichment.String": StaticStringRoutingEnrichment,
};
